import * as React from "react";
import { FeedPanel } from "../DesignSystem/formatting/FeedComponents";
import { RLink } from "../DesignSystem/RLink";

export const PatreonReminder = () => {
  return (
    <FeedPanel title={<>Support Chips!</>}>
      Did you know that Chips is supported by cool people like you?{" "}
      <RLink to="https://www.patreon.com/ChipsCompo">Donate on Patreon</RLink>{" "}
      so I can continue to work on it!
    </FeedPanel>
  );
};
